import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './style'

const MainContainer = ({ children }) => {
  const classes = useStyles()
  return (
    <Grid className={classes.mainContainer}>
      <div className={classes.contentWrapper}>{children}</div>
    </Grid>
  )
}

export default MainContainer
